import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import UserForm from '../../components/UserForm';

export default function UserEdit() {
  return (
    <div style={{ margin: '2rem' }}>
      <AdminLayout titleName='จัดการผู้ใช้'/>
      <Grid container style={{ marginTop: '4rem', marginBottom: '2rem' }}>
        <Grid item xs={12}>
          <Typography variant='h4' style={{ fontWeight: 'bold' }}>แก้ไขผู้ใช้</Typography>
        </Grid>
        <Grid item xs={12} >
          <UserForm mode='edit' />
        </Grid>
      </Grid>
    </div>
  )
}